import { frontendURL } from '../../../../helper/URLHelper';
import { ONBOARDING_GUIDE_PERMISSIONS } from 'dashboard/constants/permissions.js';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/onboarding'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_onboarding_guide',
          component: Index,
          meta: {
            permissions: ONBOARDING_GUIDE_PERMISSIONS,
          },
        },
      ],
    },
  ],
};
